import React from 'react'

import HomeIcon from '../RouterProject/Home.svg'
const Home = () => {
  return (
    <>
   <div className="home">
    <h1>Home--page</h1>
    <div className="image">
    <img src={HomeIcon} alt="Home" className='img'/>
<p className='my-4 text-md-start pra'>Home dolor, sit amet consectetur adipisicing elit. Ipsa nam nostrum at. Facere aperiam exercitationem, quia delectus blanditiis vel necessitatibus voluptatem eligendi in minus, accusamus hic, culpa rem nisi! Esse?Home dolor, sit amet consectetur adipisicing elit. Ipsa nam nostrum at. Facere aperiam exercitationem, quia delectus blanditiis vel necessitatibus voluptatem eligendi in minus, accusamus hic, culpa rem nisi! Esse?</p>
    </div>
   </div>
    </>
  )
}

export default Home